// let和var的区别
// var出的变量是函数级作用域，作用范围是在函数开始阶段和函数执行完成之前内都是存在的;
// 并且如果该函数内部还存在匿名函数等特殊函数,这个var出的变量在匿名函数中任然可以用;
// let出的变量作用域是 块作用域,在离开某一代码块,该变量就会被销毁不存在.
import axios from 'axios'
axios.defaults.withCredentials=true;
import qs from 'qs' // 这个是用于把json转成&符号拼接的参数传递
let host = process.env.API_ROOT;

import router from '../router'

export function post(url,params,callback){
  let data = qs.stringify(params)
  axios
    .post(host+url,data)
    .then(function (response) {
      callback(response)
    })
    .catch(e => {
      console.log(e)
    })
}

export function getPictureUrl(row){
  if(row.image){
    return host + row.image
  }
}

export function dateFormat(dateObj) {
  let year = dateObj.getFullYear();
  let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  let day = ("0" + dateObj.getDate()).slice(-2);
  return year + "-" + month + "-" + day;
}

export function loginCheck(content) {
  // console.log("common.js loginCheck : "+JSON.stringify(content))
  if (content === 'notLogin') {
    router.push({path: '/Login'})
  }
}

export function validatePhone(rule, value, callback) {
  // let re = /^\d+$/
  // /^[0-9]+.?[0-9]*/
  // console.log("value: "+value +" >> "+ /^\d+$/.test(value))
  if (!value) {
    callback(new Error('请输入电话号码'));
  } else if (!/^\d+$/.test(value)) {
    callback(new Error('电话号码必须是数字'));
  } else if (value.length !== 11) {
    callback(new Error('电话号码必须是11位'));
  } else {
    callback();
  }
}

export function handleImageAdded(file, Editor, cursorLocation, resetUploader) {
  let formData = new FormData();
  formData.append('file', file)
  const self = this
  axios({
    url: host + 'upload',
    method: 'POST',
    data: formData
  }).then((result) => {
    let url = host + result.data.content // Get url from response
    Editor.insertEmbed(cursorLocation, 'image', url);
    resetUploader();
  }).catch((err) => {
    console.log(err);
  })
}



// WEBPACK FOOTER //
// ./src/JavaScript/common.js